import { useMemo, useState } from 'react';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardCommerciauxTable from './DashboardCommerciauxTable/DashboardCommerciauxTable';
import { DashboardCommerciauxContext } from './DashboardCommerciaux.context';
import DashboardCommerciauxCreateModal from './DashboardCommerciauxCreateModal/DashboardCommerciauxCreateModal';
import DashboardCommerciauxUpdateModal from './DashboardCommerciauxUpdateModal/DashboardCommerciauxUpdateModal';
import { Commercial } from '../../../../../types/api/endpoints/commercial/commercial.types';
import { DashboardCommerciauxFilters } from './DashboardCommerciaux.types';
import CommerciauxFiltersModal from './CommerciauxFiltersModal/CommerciauxFiltersModal';
import AssignProspectsModal from './AssignProspectsModal/AssignProspectsModal';

export default () => {
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);
  const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
  const [isFiltersModalOpen, setFiltersModalOpen] = useState(false);
  const [isAssignModalOpen, setAssignModalOpen] = useState(false);

  const [selectedCOM, setSelectedCOM] = useState<Commercial>();

  const [filters, setFilters] = useState<DashboardCommerciauxFilters>();

  const contextValue = useMemo(
    () => ({
      isCreateModalOpen,
      setCreateModalOpen,
      isUpdateModalOpen,
      setUpdateModalOpen,
      isFiltersModalOpen,
      setFiltersModalOpen,
      isAssignModalOpen,
      setAssignModalOpen,
      selectedCOM,
      setSelectedCOM,
      filters,
      setFilters,
    }),
    [
      isCreateModalOpen,
      setCreateModalOpen,
      isUpdateModalOpen,
      setUpdateModalOpen,
      isFiltersModalOpen,
      setFiltersModalOpen,
      isAssignModalOpen,
      setAssignModalOpen,
      selectedCOM,
      setSelectedCOM,
      filters,
      setFilters,
    ]
  );

  return (
    <DashboardCommerciauxContext.Provider value={contextValue}>
      <DashboardLayout>
        <DashboardCommerciauxTable />
      </DashboardLayout>
      <DashboardCommerciauxCreateModal
        isOpen={isCreateModalOpen}
        setOpen={setCreateModalOpen}
        closeOnClickOutside
        style={{
          maxHeight: 680,
        }}
      />
      <DashboardCommerciauxUpdateModal
        isOpen={isUpdateModalOpen}
        setOpen={setUpdateModalOpen}
        closeOnClickOutside
        style={{
          maxHeight: 680,
        }}
      />
      <CommerciauxFiltersModal
        isOpen={isFiltersModalOpen}
        setOpen={setFiltersModalOpen}
        closeOnClickOutside
        style={{
          maxHeight: 680,
        }}
      />
      <AssignProspectsModal
        isOpen={isAssignModalOpen}
        setOpen={setAssignModalOpen}
        closeOnClickOutside
        style={{
          maxHeight: 680,
        }}
      />
    </DashboardCommerciauxContext.Provider>
  );
};
